import getIn from 'transmute/getIn';
import { TYPE } from '../../common-message-format/constants/keyPaths';
import { MESSAGE_HEADER } from '../../common-message-format/constants/attachmentTypes';
import { getAttachments } from '../../common-message-format/operators/getAttachments';
export const isMessageHeaderAttachment = attachment => getIn(TYPE, attachment) === MESSAGE_HEADER;
export const getMessageHeaderAttachment = message => {
  const attachments = getAttachments(message);
  if (!attachments || attachments.size === 0) return null;
  return attachments.find(isMessageHeaderAttachment) || null;
};